import React, { useRef } from 'react';

import { PanelWithCheck } from 'apps/auth/components/common/components/PanelWithCheck/PanelWithCheck';
import { CommonPage } from 'apps/auth/components/common/Layout/CommonPage/CommonPage';
import { HeaderPanel } from 'apps/auth/components/common/Layout/HeaderPanel/HeaderPanel';
import { Panel } from 'apps/auth/components/common/Panel/Panel';
import { PanelRightBlock, PanelRow } from 'apps/auth/components/common/Panel/styles';
import PopupNew from 'apps/auth/components/common/Popup/PopupNew';
import SimplePopup from 'apps/auth/components/common/Popup/SimplePopup';
import { Text } from 'apps/auth/components/common/Text/Text';
import BasePage from 'apps/auth/components/utils/BasePage';
import { USER_THEME_DARK, USER_THEME_LIGHT } from 'apps/auth/constants/Constants';
import { AUTH_PROFILE_SETTINGS } from 'apps/auth/constants/UrlConstants';
import { getCurrentSystemTheme } from 'apps/auth/helpers/utils';
import { usePageMessages } from 'apps/auth/hooks/selectors';
import { useThemeDetector } from 'apps/auth/hooks/theme';

const ProfileAppearancePage = () => {
    const { profileMenuAppearance, appearanceDark, appearanceLight, profileTheme, appearanceSystem } = usePageMessages();

    const popupRef = useRef(null);

    const { theme, setTheme, isSystemTheme } = useThemeDetector();

    const getTheme = () => {
        if (isSystemTheme) {
            return appearanceSystem;
        } else {
            return theme === USER_THEME_LIGHT ? appearanceLight : appearanceDark;
        }
    };

    return (
        <>
            <CommonPage backUrl={AUTH_PROFILE_SETTINGS}>
                <HeaderPanel title={profileMenuAppearance} />
                <Panel
                    isHoverable
                    negativeMargin
                    onClick={() => {
                        popupRef.current?.open(
                            <SimplePopup withoutBorder popupRef={popupRef}>
                                <PanelWithCheck
                                    mainText={appearanceLight}
                                    isSelected={!isSystemTheme && theme === USER_THEME_LIGHT}
                                    negativeMargin={false}
                                    onClick={(e) => {
                                        e.preventDefault();
                                        setTheme(USER_THEME_LIGHT, false);
                                        popupRef.current?.close();
                                    }}
                                />
                                <PanelWithCheck
                                    mainText={appearanceDark}
                                    isSelected={!isSystemTheme && theme === USER_THEME_DARK}
                                    negativeMargin={false}
                                    onClick={(e) => {
                                        e.preventDefault();
                                        setTheme(USER_THEME_DARK, false);
                                        popupRef.current?.close();
                                    }}
                                />
                                <PanelWithCheck
                                    type="link"
                                    mainText={appearanceSystem}
                                    isSelected={isSystemTheme}
                                    negativeMargin={false}
                                    onClick={(e) => {
                                        e.preventDefault();
                                        setTheme(getCurrentSystemTheme(), true);
                                        popupRef.current?.close();
                                    }}
                                />
                            </SimplePopup>,
                        );
                    }}
                >
                    <PanelRow>
                        <PanelRow alignStart>
                            <Text>{profileTheme}</Text>
                        </PanelRow>
                        <PanelRightBlock>
                            <Text color="secondary">{getTheme()}</Text>
                        </PanelRightBlock>
                    </PanelRow>
                </Panel>
            </CommonPage>
            <PopupNew ref={popupRef} />
        </>
    );
};

export default BasePage(ProfileAppearancePage);
